(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["Banner"] && !window.DesignMode) return;
  try {
    
   
$(document).on("shopify:section:select", function(e){

var type = 'Banner';
var EditClass = 'editbanner';


var dataset = e.target.dataset;
var dataset = JSON.parse(dataset[Object.keys(dataset)[0]]);
var sectionType = dataset['type'];
var sectionId = dataset['id'];
var eventSectionId = e.target.id.replace('shopify-section-','');
if(sectionType == type && sectionId == eventSectionId) {

//scroll
var sectionEl = document.querySelector('#shopify-section-'+sectionId);
var topPos = sectionEl.offsetTop;
var frame = document.querySelector('#swiper_Frame');
if(!window['scroll'+sectionId]) {
$(frame).animate({ scrollTop: topPos }); 
window['scroll'+sectionId] = true;
}




//re-intialize
$(document).off("shopify:section:select", sectionEl, reInit);
$(document).on("shopify:section:select", sectionEl, reInit);
function reInit() {
var mySwiper = this.querySelector('.swiper-container').swiper;
if(mySwiper) {
mySwiper.destroy( true, true );
}
window['clone'+sectionId]();
} 


var body =  document.getElementsByTagName("body")[0];
body.classList.add('editing', EditClass);
$(document).one("shopify:section:deselect",function(e){
body.classList.remove(EditClass);

//clear scroll
window['scroll'+sectionId] = undefined;

// remove re-initialize event listenener
$(document).off("shopify:section:select", sectionEl, reInit);

})
}
});   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Button"] && !window.DesignMode) return;
  try {
    


$(document).on("shopify:section:select", function(e){

var type = 'Button';
var EditClass = 'editButton';


var dataset = e.target.dataset;
var dataset = JSON.parse(dataset[Object.keys(dataset)[0]]);
var sectionType = dataset['type'];
var sectionId = dataset['id'];
var eventSectionId = e.target.id.replace('shopify-section-','');
if(sectionType == type && sectionId == eventSectionId) {

//scroll
var sectionEl = document.querySelector('#shopify-section-'+sectionId);
var topPos = sectionEl.offsetTop;
var frame = document.querySelector('#swiper_Frame');
if(!window['scroll'+sectionId]) {
$(frame).animate({ scrollTop: topPos }); 
window['scroll'+sectionId] = true;
}






var body =  document.getElementsByTagName("body")[0];
body.classList.add('editing', EditClass);
$(document).one("shopify:section:deselect",function(e){
body.classList.remove(EditClass);

//clear scroll
window['scroll'+sectionId] = undefined;


})
}
});   



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Favicon-and-Scrollbar"]) return;
  try {
    

 $(document).on("shopify:section:select",'#shopify-section-Favicon-and-Scrollbar',function(e){

 $('body').addClass('editing editfavicon');

     $(document).on("shopify:section:deselect",'#shopify-section-Favicon-and-Scrollbar',function(e){
        $('body').removeClass('editfavicon');
      
     });   
}); 
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Header-Notification"]) return;
  try {
    
 $(document).on("shopify:section:select",'#shopify-section-Header-Notification',function(e){
 $('body').addClass('editing editnotification').trigger( "updatelayout" );
     $(document).on("shopify:section:deselect",'#shopify-section-Header-Notification',function(e){
        $('body').removeClass('editnotification').trigger( "updatelayout" );
     });   
});               

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Header"]) return;
  try {
    



$(document).on("shopify:section:select",'#shopify-section-Header',function(e){
$('body').addClass('editing editheader');
$(document).one("shopify:section:deselect",function(e){
$('body').removeClass('editheader');
})
}) 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Image"] && !window.DesignMode) return;
  try {
    
   
$(document).on("shopify:section:select", function(e){

var type = 'Image';
var EditClass = 'editImage';


var dataset = e.target.dataset;
var dataset = JSON.parse(dataset[Object.keys(dataset)[0]]);
var sectionType = dataset['type'];
var sectionId = dataset['id'];
var eventSectionId = e.target.id.replace('shopify-section-','');
if(sectionType == type && sectionId == eventSectionId) {

//scroll
var sectionEl = document.querySelector('#shopify-section-'+sectionId);
var topPos = sectionEl.offsetTop;
var frame = document.querySelector('#swiper_Frame');
if(!window['scroll'+sectionId]) {
$(frame).animate({ scrollTop: topPos }); 
window['scroll'+sectionId] = true;
}






var body =  document.getElementsByTagName("body")[0];
body.classList.add('editing', EditClass);
$(document).one("shopify:section:deselect",function(e){
body.classList.remove(EditClass);

//clear scroll
window['scroll'+sectionId] = undefined;


})
}
});   


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["List-of-Collections"] && !window.DesignMode) return;
  try {
    

   
$(document).on("shopify:section:select", function(e){

var type = 'List-of-Collections';
var EditClass = 'editCollections';


var dataset = e.target.dataset;
var dataset = JSON.parse(dataset[Object.keys(dataset)[0]]);
var sectionType = dataset['type'];
var sectionId = dataset['id'];
var eventSectionId = e.target.id.replace('shopify-section-','');
if(sectionType == type && sectionId == eventSectionId) {

//scroll
var sectionEl = document.querySelector('#shopify-section-'+sectionId);
var topPos = sectionEl.offsetTop;
var frame = document.querySelector('#swiper_Frame');
if(!window['scroll'+sectionId]) {
$(frame).animate({ scrollTop: topPos }); 
window['scroll'+sectionId] = true;
}






var body =  document.getElementsByTagName("body")[0];
body.classList.add('editing', EditClass);
$(document).one("shopify:section:deselect",function(e){
body.classList.remove(EditClass);

//clear scroll
window['scroll'+sectionId] = undefined;


})
}
});   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Loader"]) return;
  try {
    

 $(document).on("shopify:section:select",'#shopify-section-Loader',function(e){
 $('body').addClass('editing editloader');
     $(document).on("shopify:section:deselect",'#shopify-section-Loader',function(e){
        $('body').removeClass('editloader');
     });   
});   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Mobile-Menu"]) return;
  try {
    

 $(document).on("shopify:section:select",'#shopify-section-Mobile-Menu',function(e){
 paneledit();
 $('body').addClass('editing editpanel');

     $(document).on("shopify:section:deselect",'#shopify-section-Mobile-Menu',function(e){
        $('body').removeClass('editpanel');
        paneledit();
     });   
}); 

function paneledit() {
    $("#shopify-section-Mobile-Menu").panel({
      close: function(event, ui) {
        $('#swiper_Frame').removeClass('popup-open');
       stopBodyScrolling(false); 
      },
      open: function(event,ui) {
             var vpH = window.innerHeight;  
      $('#swiper_Frame').addClass('popup-open');
document.documentElement.style.height = vpH.toString() + "px";
$('#swiper_Frame')[0].style.height = vpH.toString() + "px";
stopBodyScrolling(true); 
      }
      
    });
}                 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Parallax"] && !window.DesignMode) return;
  try {
    

  
$(document).on("shopify:section:select", function(e){

var type = 'Parallax';
var EditClass = 'editParallax';


var dataset = e.target.dataset;
var dataset = JSON.parse(dataset[Object.keys(dataset)[0]]);
var sectionType = dataset['type'];
var sectionId = dataset['id'];
var eventSectionId = e.target.id.replace('shopify-section-','');
if(sectionType == type && sectionId == eventSectionId) {

//scroll
var sectionEl = document.querySelector('#shopify-section-'+sectionId);
var topPos = sectionEl.offsetTop;
var frame = document.querySelector('#swiper_Frame');
if(!window['scroll'+sectionId]) {
$(frame).animate({ scrollTop: topPos }); 
window['scroll'+sectionId] = true;
}


// refresh Rellax
var rellaxEl = document.querySelector('#shopify-section-'+sectionId+' [data-rellax]');
console.log(rellaxEl);
console.log(rellaxEl.rellax);
if(rellaxEl.rellax !== undefined) {
rellaxEl.rellax.refresh();
}else{
rellaxEl.setAttribute('data-rellax-percentage','0.08');
new Rellax(rellaxEl, {
    wrapper: '#swiper_Frame',
    round: true,
    vertical: true,
    horizontal: false
  });   
}



var body =  document.getElementsByTagName("body")[0];
body.classList.add('editing', EditClass);
$(document).one("shopify:section:deselect",function(e){
body.classList.remove(EditClass);

//clear scroll
window['scroll'+sectionId] = undefined;


})
}
});   





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Products"] && !window.DesignMode) return;
  try {
    


   
$(document).on("shopify:section:select", function(e){

var type = 'Products';
var EditClass = 'editProducts';


var dataset = e.target.dataset;
var dataset = JSON.parse(dataset[Object.keys(dataset)[0]]);
var sectionType = dataset['type'];
var sectionId = dataset['id'];
var eventSectionId = e.target.id.replace('shopify-section-','');
if(sectionType == type && sectionId == eventSectionId) {

//scroll
var sectionEl = document.querySelector('#shopify-section-'+sectionId);
var topPos = sectionEl.offsetTop;
var frame = document.querySelector('#swiper_Frame');
if(!window['scroll'+sectionId]) {
$(frame).animate({ scrollTop: topPos }); 
window['scroll'+sectionId] = true;
}






var body =  document.getElementsByTagName("body")[0];
body.classList.add('editing', EditClass);
$(document).one("shopify:section:deselect",function(e){
body.classList.remove(EditClass);

//clear scroll
window['scroll'+sectionId] = undefined;


})
}
});   



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Setup-Instructions"]) return;
  try {
    



$(document).on("shopify:section:select", function(e){

var type = 'Setup-Instructions';
var EditClass = 'editSetup';


var dataset = e.target.dataset;
var dataset = JSON.parse(dataset[Object.keys(dataset)[0]]);
var sectionType = dataset['type'];
var sectionId = dataset['id'];
var eventSectionId = e.target.id.replace('shopify-section-','');
if(sectionType == type && sectionId == eventSectionId) {







var body =  document.getElementsByTagName("body")[0];
body.classList.add('editing', EditClass);
$(document).one("shopify:section:deselect",function(e){
body.classList.remove(EditClass);
})

$(document).one("shopify:section:load",function(e){
if (window.location !== window.parent.location) {	 
  var virtualGuide = document.querySelector("#Setup-Instructions");
  if(virtualGuide.innerHTML == 'true') {
    console.log('start guide');
    startGuide();
  }else{
   console.log('remove guide');
   var guideWrapEl = document.querySelector('#guideWrap');
   guideWrapEl.remove();
  }
}
})


}




});   

if (window.location !== window.parent.location) {	  
  var virtualGuide = document.querySelector("#Setup-Instructions");
  if(virtualGuide.innerHTML == 'true') {
    console.log('start guide');
    startGuide();
  }else{
   console.log('remove guide');
   var guideWrapEl = document.querySelector('#guideWrap');
   guideWrapEl.remove();
  }
}

function startGuide() {

document.body.classList.add('virtualGuide'); 
  
  
var stringToHTML = function (str) {
		var parser = new DOMParser();
		var doc = parser.parseFromString(str, 'text/html');
		return doc.body.children[0];
}; 
  
 
var guideWrapEl = document.querySelector('#guideWrap');
var filters = '?modestbranding=1&VQ=HD1080';  
if(!guideWrapEl) {  
document.body.prepend(stringToHTML('<div id="guideWrap"><h2>Overview</h2><div class="flex-video youtube widescreen"><iframe width="1920" height="1080" src="https://www.youtube.com/embed/qJsRdVNCcn4'+ filters +'" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div><div class="more"><h3>When you finish watching click the link below</h3><a href="https://digitalbrandz.marketing/pages/tutorials">More Advanced Tips</a></div></div>'));
}  
  
 
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Text"] && !window.DesignMode) return;
  try {
    

$(document).on("shopify:section:select", function(e){

var type = 'Text';
var EditClass = 'editText';


var dataset = e.target.dataset;
var dataset = JSON.parse(dataset[Object.keys(dataset)[0]]);
var sectionType = dataset['type'];
var sectionId = dataset['id'];
var eventSectionId = e.target.id.replace('shopify-section-','');
if(sectionType == type && sectionId == eventSectionId) {

//scroll
var sectionEl = document.querySelector('#shopify-section-'+sectionId);
var topPos = sectionEl.offsetTop;
var frame = document.querySelector('#swiper_Frame');
if(!window['scroll'+sectionId]) {
$(frame).animate({ scrollTop: topPos }); 
window['scroll'+sectionId] = true;
}






var body =  document.getElementsByTagName("body")[0];
body.classList.add('editing', EditClass);
$(document).one("shopify:section:deselect",function(e){
body.classList.remove(EditClass);

//clear scroll
window['scroll'+sectionId] = undefined;


})
}
});   



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Video"] && !window.DesignMode) return;
  try {
    
   
$(document).on("shopify:section:select", function(e){

var type = 'Video';
var EditClass = 'editVideo';


var dataset = e.target.dataset;
var dataset = JSON.parse(dataset[Object.keys(dataset)[0]]);
var sectionType = dataset['type'];
var sectionId = dataset['id'];
var eventSectionId = e.target.id.replace('shopify-section-','');
if(sectionType == type && sectionId == eventSectionId) {

//scroll
var sectionEl = document.querySelector('#shopify-section-'+sectionId);
var topPos = sectionEl.offsetTop;
var frame = document.querySelector('#swiper_Frame');
if(!window['scroll'+sectionId]) {
$(frame).animate({ scrollTop: topPos }); 
window['scroll'+sectionId] = true;
}






var body =  document.getElementsByTagName("body")[0];
body.classList.add('editing', EditClass);
$(document).one("shopify:section:deselect",function(e){
body.classList.remove(EditClass);

//clear scroll
window['scroll'+sectionId] = undefined;


})
}
});   


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Youtube-Embed"] && !window.DesignMode) return;
  try {
    
   
$(document).on("shopify:section:select", function(e){

var type = 'Youtube-Embed';
var EditClass = 'editYoutubeVideo';


var dataset = e.target.dataset;
var dataset = JSON.parse(dataset[Object.keys(dataset)[0]]);
var sectionType = dataset['type'];
var sectionId = dataset['id'];
var eventSectionId = e.target.id.replace('shopify-section-','');
if(sectionType == type && sectionId == eventSectionId) {

//scroll
var sectionEl = document.querySelector('#shopify-section-'+sectionId);
var topPos = sectionEl.offsetTop;
var frame = document.querySelector('#swiper_Frame');
if(!window['scroll'+sectionId]) {
$(frame).animate({ scrollTop: topPos }); 
window['scroll'+sectionId] = true;
}






var body =  document.getElementsByTagName("body")[0];
body.classList.add('editing', EditClass);
$(document).one("shopify:section:deselect",function(e){
body.classList.remove(EditClass);

//clear scroll
window['scroll'+sectionId] = undefined;


})
}
});   


  } catch(e) { console.error(e); }
})();

})();
